import { render, staticRenderFns } from "./com-page-operate.vue?vue&type=template&id=4067dc57&"
import script from "./com-page-operate.vue?vue&type=script&lang=js&"
export * from "./com-page-operate.vue?vue&type=script&lang=js&"
import style0 from "./com-page-operate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports